module.exports = __webpack_public_path__ + "static/media/main2.675602c0.svg";